
import { useState } from "react";
import { FaStar, FaRegStar } from "react-icons/fa";
import { FiUser, FiMessageSquare, FiSend } from "react-icons/fi";
import { createReview } from "../../../../../../services/reviewService";
import "./review.scss";

export default function RatingForm({ itemId, tripName }) {
  const [formData, setFormData] = useState({
    userName: "",
    message: "",
    rating: 0,
  });
  const [hover, setHover] = useState(0);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setSuccess("");

    if (!formData.userName.trim() || !formData.message.trim() || formData.rating === 0) {
      setError("Please fill in all fields and select a rating");
      return;
    }

    if (formData.message.length < 20) {
      setError("Please write a more detailed review (minimum 20 characters)");
      return;
    }

    setLoading(true);

    try {
      await createReview({
        name: formData.userName,
        trip: itemId,
        stars: formData.rating,
        message: formData.message,
        date: new Date().toLocaleDateString('en-US', { 
          year: 'numeric', 
          month: 'long', 
          day: 'numeric' 
        })
      });
      
      setSuccess("Thank you for your review! It has been submitted successfully.");
      setFormData({
        userName: "",
        message: "",
        rating: 0,
      });
    } catch (err) {
      setError("Failed to submit review. Please try again.");
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="review-form-container">
      <div className="form-header">
        <h3>
          <FiMessageSquare /> Share Your Experience
        </h3>
        <p>Tell us about your adventure with {tripName}</p>
      </div>

      <form onSubmit={handleSubmit} className="review-form">
        <div className="form-group">
          <label htmlFor="userName">
            <FiUser /> Your Name
          </label>
          <input
            type="text"
            id="userName"
            name="userName"
            placeholder="Enter your name"
            value={formData.userName}
            onChange={handleInputChange}
            required
          />
        </div>

        <div className="form-group">
          <label>Your Rating</label>
          <div className="star-rating">
            {[1, 2, 3, 4, 5].map((value) => (
              <button
                type="button"
                key={value}
                onClick={() => setFormData(prev => ({ ...prev, rating: value }))}
                onMouseEnter={() => setHover(value)}
                onMouseLeave={() => setHover(0)}
                className="star-btn"
              >
                {(hover || formData.rating) >= value ? (
                  <FaStar className="star filled" />
                ) : (
                  <FaRegStar className="star" />
                )}
              </button>
            ))}
            <span className="rating-text">
              {formData.rating > 0 ? `${formData.rating}.0 stars` : "Click to rate"}
            </span>
          </div>
        </div>

        <div className="form-group">
          <label htmlFor="message">Your Review</label>
          <textarea
            id="message"
            name="message"
            placeholder="Share details of your experience, what you liked, any suggestions..."
            value={formData.message}
            onChange={handleInputChange}
            rows={5}
            required
          />
          <div className="char-count">
            {formData.message.length} / 500 characters
          </div>
        </div>

        {error && <div className="alert error">{error}</div>}
        {success && <div className="alert success">{success}</div>}

        <button type="submit" className="submit-btn" disabled={loading}>
          {loading ? (
            <>
              <span className="spinner"></span>
              Submitting...
            </>
          ) : (
            <>
              <FiSend /> Submit Review
            </>
          )}
        </button>
      </form>
    </div>
  );
}
